define.alias("shared/components/shared/ui/social-set-switcher", "settings/components/shared/ui/social-set-switcher");